module.exports = __webpack_public_path__ + "img/notification.b6a4c486.png";